import React from 'react';

import {
  activityTemplates,
  routeDirectory
} from 'modules';
import {
  useNavigate,
  useParams
} from 'react-router-dom';

import { TabBar } from 'iron-forge-react-modules';
import { Paper } from '@mui/material';
import * as PendingWritesTab from './PendingWritesTab/PendingWritesTab';
import * as SOAPRequestTab from './SOAPRequestTab/SOAPRequestTab';
import * as WriteRequestsTab from './ValidationErrorsTab/ValidationErrorsTab';



type ITabId = 'pendingWrites' | 'validationErrors' | 'soap';

export const NetSuiteActivity: React.FC = () => {
  const params = useParams<{ tabId: ITabId; }>();
  const navigate = useNavigate();

  return (
    <activityTemplates.AdminActivityTemplate.FC>
      <TabBar.FC
        tabId={params.tabId ?? 'writeRequests'}
        tabs={[
          {
            id: 'pendingWrites',
            label: "Pending Writes"
          },
          {
            id: 'validationErrors',
            label: "Validation Errors"
          },
          {
            id: 'soap',
            label: "SOAP API"
          }
        ]}
        onSelectTab={tabId => navigate(routeDirectory.admin.netSuite.path(tabId as ITabId))} />

      <Paper>
        {params.tabId === 'pendingWrites' && (
          <PendingWritesTab.FC />
        )}

        {params.tabId === 'validationErrors' && (
          <WriteRequestsTab.FC />
        )}

        {params.tabId === 'soap' && (
          <SOAPRequestTab.FC />
        )}
      </Paper>
    </activityTemplates.AdminActivityTemplate.FC>
  );
};
